// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
var ShieldStar = React.forwardRef(function ShieldStar(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ShieldStar" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2L3 5.88889V11.0909C3 16.1364 6.84 20.8545 12 22C17.16 20.8545 21 16.1364 21 11.0909V5.88889L12 2ZM12 5.88889L13.3279 10.133H17.625L14.1486 12.7559L15.4764 17L12 14.377L8.52356 17L9.85144 12.7559L6.375 10.133H10.6721L12 5.88889Z", fill: "currentColor" }))));
});
ShieldStar.displayName = 'ShieldStar';
export default ShieldStar;
//# sourceMappingURL=ShieldStar.js.map